module.exports = __webpack_public_path__ + "static/media/logo_name_orange.59fa4aa8.svg";